import { motion } from "framer-motion";
import { Activity, PlusSquare, LayoutDashboard, History, Brain, LogOut } from "lucide-react";

const tabs = [
  { id: "new", label: "New Trade", icon: PlusSquare },
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard },
  { id: "history", label: "History", icon: History },
  { id: "coach", label: "AI Coach", icon: Brain },
];

export default function Navbar({ view, setView, user, onLogout }) {
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-black/60 border-b border-[#00F0FF]/40">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 flex items-center justify-between h-16">
        {/* Logo */}
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => setView("dashboard")} data-testid="app-logo">
          <div className="w-10 h-10 rounded-lg overflow-hidden border border-[#00F0FF]/60 glow-cyan p-0.5 bg-[#050505] flex items-center justify-center flex-shrink-0">
            <img src="/logo.png" alt="Mwangi Trades Logo" className="w-full h-full object-cover rounded-md" />
          </div>
          <div className="leading-none">
            <div className="font-display font-black text-base sm:text-lg tracking-tight text-white flex items-center gap-1">
              MWANGI<span className="text-[#00F0FF] text-glow-cyan">TRADES</span>
            </div>
            <div className="text-[9px] sm:text-[10px] text-[#00F0FF] tracking-[0.25em] uppercase font-mono mt-0.5">ICC MAFIA JOURNAL</div>
          </div>
        </div>

        {/* Nav tabs */}
        <nav className="flex items-center gap-1 sm:gap-2">
          {tabs.map((t) => {
            const Icon = t.icon;
            const active = view === t.id;
            return (
              <button
                key={t.id}
                data-testid={`nav-${t.id}`}
                onClick={() => setView(t.id)}
                className={`relative px-3 sm:px-4 py-2 text-xs sm:text-sm flex items-center gap-2 transition-colors ${
                  active ? "text-[#00F0FF]" : "text-[#848D97] hover:text-white"
                }`}
              >
                <Icon className="w-4 h-4" />
                <span className="hidden sm:inline">{t.label}</span>
                {active && (
                  <motion.div
                    layoutId="nav-underline"
                    className="absolute -bottom-[9px] left-0 right-0 h-[2px] bg-[#00F0FF] glow-cyan"
                  />
                )}
              </button>
            );
          })}
        </nav>

        {/* User + Logout */}
        <div className="flex items-center gap-3 ml-2">
          {user && (
            <span className="hidden md:flex items-center gap-1.5 text-[11px] text-[#00F0FF] tracking-wider font-mono font-bold">
              <span className="w-2 h-2 rounded-full bg-[#00FF41] animate-pulse inline-block" />
              Mwangi
            </span>
          )}
          <button
            onClick={onLogout}
            title="Sign out"
            data-testid="logout-btn"
            className="flex items-center gap-1.5 px-3 py-1.5 border border-[#1A1A24] text-[#848D97] hover:text-[#FF003C] hover:border-[#FF003C]/50 text-xs transition-colors"
          >
            <LogOut className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">Sign out</span>
          </button>
        </div>
      </div>
    </header>
  );
}
